module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-12.d4f102be.png";